'use client';

import React from 'react';
import { TooltipProvider } from '@/components/ui/tooltip';

interface AppTooltipProviderProps {
  children: React.ReactNode;
}

export default function AppTooltipProvider({ children }: AppTooltipProviderProps) {
  return (
    <TooltipProvider delayDuration={220} skipDelayDuration={280} disableHoverableContent>
      {children}
    </TooltipProvider>
  );
}
